import { render, staticRenderFns } from "./TeamMemberChip.vue?vue&type=template&id=c7738416&scoped=true"
import script from "./TeamMemberChip.vue?vue&type=script&lang=ts"
export * from "./TeamMemberChip.vue?vue&type=script&lang=ts"
import style0 from "./TeamMemberChip.vue?vue&type=style&index=0&id=c7738416&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7738416",
  null
  
)

export default component.exports